import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateWord } from '../../store/actions/wordAction'
import { Redirect } from 'react-router-dom'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Container from '@material-ui/core/Container';

export class EditExistingWord extends Component {
    state = {
        id: this.props.location.state.id,
        Language1: this.props.location.state.Language1,
        Language2: this.props.location.state.Language2,
        Language3: this.props.location.state.Language3,
        Language4: this.props.location.state.Language4,
        Description1: this.props.location.state.Description1,
        Description2: this.props.location.state.Description2,
        Description3: this.props.location.state.Description3,
        Description4: this.props.location.state.Description4,
        set: this.props.location.state.set,
        sets: this.props.location.state.sets
      }

handleChange=(e)=>{
    this.setState({
        [e.target.id]: e.target.value
      })
}
handleSubmit = (e) => {
    e.preventDefault();
    // console.log(this.state);
    delete this.state.sets;
    this.setState(this.state);
    this.props.updateWord(this.state);
    this.props.history.push('/wordcard');
  }

  handleChangeSelect=(event)=> {
    console.log(event);
    this.setState({ 
     set: event.target.value
 });
}
//   componentWillReceiveProps(nextProps) {
// alert(nextProps.location.state.id);
//         this.setState({ id: nextProps.location.state.id,
//             Language1: nextProps.location.state.Language1});

//       }
// componentDidMount() {
//     alert("mount");
//     this.setState({ id: this.props.location.state.id,
//         Language1: this.props.location.state.Language1});
//     console.log(this.props);
//   }
componentDidMount() {
    // this.setState({     
    //     Language4:this.state.Language4 || "",
    //     Description4: "",
    //     Description3: ""
    // });
if(this.state.Language4==undefined)
{
    this.setState({ 
        Language4: ""
    });
}
if(this.state.Description4==undefined)
{
    this.setState({ 
        Description4: ""
    });
}
if(this.state.Description3==undefined)
{
    this.setState({ 
        Description3: ""
    });
}
}
    render() {

        return (
        <Container maxWidth="xl">
            <Paper className="paper-container">
            <div className="container">
                    <form className="white" onSubmit={this.handleSubmit}>
                    <h5 className="grey-text text-darken-3">Editar una nueva oración</h5>



                    <TextField fullWidth 
                        id="id"
                        label="id"
                        className="id"
                        value={this.state.id}
                        onChange={this.handleChange}
                        margin="dense"
                        />

                        <br></br>
                        <TextField fullWidth 
                        id="Language1"
                        label="Language1"
                        className="Language1"
                        value={this.state.Language1}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField fullWidth 
                        id="Language2"
                        label="Language2"
                        className="Language2"
                        value={this.state.Language2}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField fullWidth 
                        id="Language3"
                        label="Language3"
                        className="Language3"
                        value={this.state.Language3}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField fullWidth 
                        id="Language4"
                        label="Language4"
                        className="Language4"
                        value={this.state.Language4}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField fullWidth 
                        id="Description1"
                        label="Description1"
                        className="Description1"
                        value={this.state.Description1}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <TextField fullWidth 
                        id="Description2"
                        label="Description2"
                        className="Description2"
                        value={this.state.Description2}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <TextField fullWidth 
                        id="Description3"
                        label="Description3"
                        className="Description3"
                        value={this.state.Description3}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <TextField fullWidth 
                        id="Description4"
                        label="Description4"
                        className="Description4"
                        value={this.state.Description4}
                        onChange={this.handleChange}
                        margin="dense"
                        />
                        <br></br>
                        <br></br>
                        <FormControl >
                            <InputLabel htmlFor="name-simple">Set</InputLabel>
                                <Select
                                value={this.state.set}
                                onChange={this.handleChangeSelect}
                                inputProps={{
                                    name: 'name',
                                    id: 'name-simple',
                                }}
                                >

                                                                    {

                                    (typeof this.state.sets != 'undefined')  && this.state.sets.map(se => (
  
                                    <MenuItem value={se.name}>{se.name}</MenuItem>
                                    )
                                    )}
                                </Select>
                        </FormControl>

                     <br></br>
                     <br></br>



                        <Button type="submit" value="Submit" variant="contained" color="secondary">
                              Update
                        </Button>
                  
                    {/* <div className="input-field">
                        <button className="btn pink lighten-1">Create</button>
                    </div> */}
                    </form>
                </div>
                </Paper>
            </Container>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateWord: (word) => dispatch(updateWord(word))
    }
  }
  
  export default connect(null, mapDispatchToProps)(EditExistingWord)






//rafc
//rce